const locale = {
  TotalText: '共',
  ItemText: '条',
  UnnamedColumn: '未命名列',
  EditTable: '编辑表格',
  RestoreDefault: '恢复默认',
  VisibleInfo: '显示的信息',
  HiddenInfo: '隐藏的信息',
  Search: '搜索',
  BatchOperations: '批量操作',
  BatchOperationsWithCount: '批量操作(已选:{count}条)',
  BatchOperationsMobileSelected: '已选:{count}条',
  Cancel: '取消',
  Confirm: '确定',
  All: '全部'
};

export default locale;
